import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};
const stagger = { visible: { transition: { staggerChildren: 0.1 } } };

const PACKAGING_FEATURES = [
  {
    icon: '🎁',
    title: 'Signature Gift Box',
    desc: 'Every piece arrives in our hand-finished black and gold gift box — ready to present.',
  },
  {
    icon: '📜',
    title: 'Certificate of Authenticity',
    desc: 'A signed certificate documenting the gemstone origin, grade, and provenance.',
  },
  {
    icon: '🛡️',
    title: 'Jewellery Care Card',
    desc: 'Expert care instructions tailored to your specific gemstone type.',
  },
  {
    icon: '✉️',
    title: 'Personalised Note',
    desc: 'Add a handwritten message for gifting — complimentary on every order.',
  },
];

const PackagingSection = () => (
  <section className="packaging-section" aria-labelledby="packaging-heading">
    <div className="packaging-section__inner">
      <motion.div
        className="packaging-section__content"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={stagger}
      >
        <motion.p className="roha-eyebrow" variants={fadeUp}>
          The Roha Experience
        </motion.p>
        <motion.h2 id="packaging-heading" variants={fadeUp}>
          Premium Packaging,<br />Included with Every Order
        </motion.h2>
        <motion.p className="packaging-section__sub" variants={fadeUp}>
          We believe the unboxing is part of the luxury. Every Roha order is presented
          in our signature packaging — crafted to make every moment memorable.
        </motion.p>

        <motion.div className="packaging-features" variants={stagger} role="list">
          {PACKAGING_FEATURES.map((f) => (
            <motion.div key={f.title} className="packaging-feature" variants={fadeUp} role="listitem">
              <span className="packaging-feature__icon" aria-hidden="true">{f.icon}</span>
              <div>
                <h3 className="packaging-feature__title">{f.title}</h3>
                <p className="packaging-feature__desc">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div variants={fadeUp} style={{ marginTop: '2rem' }}>
          <Link to="/products" className="roha-button roha-button--solid">
            Shop & Experience It
          </Link>
        </motion.div>
      </motion.div>

      <motion.div
        className="packaging-section__visual"
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        aria-hidden="true"
      >
        <div className="packaging-box">
          <div className="packaging-box__lid">
            <span className="packaging-box__logo">Roha</span>
          </div>
          <div className="packaging-box__body">
            <div className="packaging-box__gem">💎</div>
            <div className="packaging-box__ribbon"></div>
          </div>
        </div>
        <div className="packaging-glow" aria-hidden="true"></div>

        {/* Floating badges */}
        <div className="packaging-badge packaging-badge--1">
          <span>🎁</span> Gift Ready
        </div>
        <div className="packaging-badge packaging-badge--2">
          <span>📜</span> Certified
        </div>
        <div className="packaging-badge packaging-badge--3">
          <span>✈️</span> Worldwide
        </div>
      </motion.div>
    </div>
  </section>
);

export default PackagingSection;
